module.exports = __webpack_public_path__ + "static/shoe-layer-2-d5516ba2e21282abaa4574764a10aa4f.png";